/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React, { useState, useEffect, useRef } from "react";
import { View } from "react-native";
import ReactPlayer from "react-player";
import Rodal from "rodal";
import "rodal/lib/rodal.css";

import { skaleOverlayBlue } from "config/UpduoColors";

interface IntroVideoModalProps {
  visible: boolean;
  onClose: Function;
  disableProceedToSession: boolean;
  onProceedToSession: Function;
  videoUrl: string;
}

export default function IntroVideoModal({
  visible,
  onClose,
  disableProceedToSession,
  onProceedToSession,
  videoUrl,
}: IntroVideoModalProps) {
  const playerRef = useRef<any>();

  const [hasVideoEnded, setHasVideoEnded] = useState(false);

  useEffect(() => {
    return () => {
      _handleResetVideo();
    };
  }, []);

  useEffect(() => {
    if (hasVideoEnded && !disableProceedToSession) {
      onProceedToSession();
    }
  }, [hasVideoEnded]);

  useEffect(() => {
    if (visible) {
      playerRef?.current?.player?.player?.play();
    } else {
      _handleResetVideo();
    }
  }, [visible]);

  const _handleResetVideo = () => {
    playerRef?.current?.player?.player?.seekTo(0);
    playerRef?.current?.player?.player?.pause();
  };

  return (
    <Rodal
      visible={visible}
      customStyles={{
        backgroundColor: "transparent",
        boxShadow: "0 0px 0px rgba(0, 0, 0, 0)",
        marginTop: 150,
      }}
      customMaskStyles={{ backgroundColor: skaleOverlayBlue }}
      onClose={onClose}
    >
      <View
        style={{
          flex: 1,
          padding: 30,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <View style={{ flex: 0 }}>
          <View
            style={{
              width: 640,
              height: 360,
              borderRadius: 12,
              overflow: "hidden",
            }}
          >
            <ReactPlayer
              controls={true}
              muted={false}
              playing={false}
              url={videoUrl}
              height={"360px"}
              width={"640px"}
              onEnded={() => {
                setHasVideoEnded(true);
              }}
              ref={playerRef}
              config={{
                youtube: {
                  playerVars: {
                    iv_load_policy: 3,
                    modestbranding: 1,
                    rel: 0,
                    showinfo: 0,
                  },
                },
              }}
            />
          </View>
        </View>
      </View>
    </Rodal>
  );
}
